import { useEffect, useRef } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BUILD_VERSION } from "@/lib/buildVersion";

const API = process.env.REACT_APP_BACKEND_URL || "";
const POLL_MS = 60000;

export default function VersionUpdateNotifier() {
  const notifiedRef = useRef(false);

  useEffect(() => {
    // Dev-only no-op. Under `craco start`, REACT_APP_BUILD_VERSION is baked
    // once at dev-server boot and never refreshed by HMR — so every bump of
    // app_version.json makes the server race ahead of the frozen bundle and
    // this notifier fires forever. The notifier only has meaning in a real
    // production build (a user holding a stale tab after a deploy), so we
    // skip it entirely when NODE_ENV !== 'production'.
    if (process.env.NODE_ENV !== "production") return;

    let cancelled = false;
    let timer = null;

    const check = async () => {
      if (cancelled || notifiedRef.current) return;
      try {
        const { data } = await axios.get(`${API}/api/system/version`, {
          headers: { "Cache-Control": "no-cache" },
        });
        if (cancelled || notifiedRef.current) return;
        const remoteLabel =
          data?.label || (data?.version ? `v${data.version}` : "");
        if (
          remoteLabel &&
          BUILD_VERSION &&
          remoteLabel !== BUILD_VERSION
        ) {
          notifiedRef.current = true;
          console.info(
            `[VersionUpdateNotifier] loaded=${BUILD_VERSION} server=${remoteLabel} — prompting reload`
          );
          toast("גרסה חדשה זמינה", {
            description: `הגרסה שטעונה בדפדפן: ${BUILD_VERSION} · הגרסה בשרת: ${remoteLabel}. רענון יטעין את החדשה.`,
            duration: Infinity,
            action: {
              label: "רענני עכשיו",
              onClick: () => window.location.reload(),
            },
          });
        }
      } catch {
        // network error / offline — try again on next tick
      }
    };

    check();
    timer = setInterval(check, POLL_MS);

    const onVis = () => {
      if (document.visibilityState === "visible") check();
    };
    document.addEventListener("visibilitychange", onVis);

    return () => {
      cancelled = true;
      if (timer) clearInterval(timer);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, []);

  return null;
}
